<template>
  <div>
    <v-alert  :value="true"  v-if="errorMessage != null" type="error" >{{ errorMessage }}</v-alert>
    <PageIntro v-if="loggedOut === true"
      :heading="'<span>' +configStrings.productName + '</span>'"
      :body="'<p>You are now signed out of your  ' +configStrings.productName + '.</p>'" />
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro'

  export default {
    components: {
      PageIntro
    },
    data () {
      return {
        errorMessage: null,
        successMessage: null,
        loggedOut: false
      }
    },
    mounted () {
      console.log('Hit AUTH LOGOUT script')
      this.$signOut();
      this.successMessage = 'You have successfully signed out'
      this.loggedOut = true
    }
  }
</script>